<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M16 9.85c-.06.04-1.07.61-1.07 1.87a2.2 2.2 0 0 0 1.32 1.99c0 .03-.2.7-.68 1.4-.42.6-.85 1.2-1.52 1.2s-.84-.39-1.61-.39c-.76 0-1.02.4-1.63.4-.62 0-1.04-.55-1.53-1.24a6 6 0 0 1-1.03-3.26c0-1.9 1.24-2.92 2.46-2.92.65 0 1.2.43 1.6.43s1-.45 1.74-.45c.28 0 1.28.02 1.94.97m-2.3-1.78c.3-.37.52-.87.52-1.37q0-.1-.02-.2a2.2 2.2 0 0 0-1.45.74c-.28.32-.54.83-.54 1.34l.02.17.13.02c.45 0 1.01-.3 1.34-.7"
      />
      <rect
        width="14.5"
        height="22.5"
        x="4.75"
        y=".75"
        stroke="inherit"
        stroke-width="1.5"
        fill="none"
        rx="3.25"
      />
    </svg>
  </span>
</template>
